module.exports = __webpack_public_path__ + "assets/img/mask-group-3.16377e4e.png";